import { MotionValue } from '../index.js';

var isMotionValue = function (value) {
    return value instanceof MotionValue;
};

export { isMotionValue };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/value/utils/is-motion-value.js
// module id = 10
// module chunks = 0